import { render, staticRenderFns } from "./Subsection.vue?vue&type=template&id=f553924e&"
import script from "./Subsection.vue?vue&type=script&lang=js&"
export * from "./Subsection.vue?vue&type=script&lang=js&"
import style0 from "./Subsection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports